import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  ProductHistory,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}ownerProducts/files`;

const getFilesForProductsCommand = async ({
  ownerProductIds,
}: {
  ownerProductIds: string[];
}): Promise<
  BackResponse<Record<string, ProductHistory[]>> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<Record<string, ProductHistory[]>>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.POST,
        json: {
          ownerProductIds,
        },
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getFilesForProductsCommand;
